
export default {
  name: 'CpmCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "How to improve CPM?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Here are some proven ways that can enhance the CPM value: Create high-quality content. Improve floors. Team up with the demand side. Experiment with different ad units. Add new units. Focus on SEO."
        }
      },{
        "@type": "Question",
        "name": "How do you calculate CPM on a calculator?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To calculate the CPM formula, divide the ad campaign's total budget by the number of impressions, then multiply it by 1,000."
        }
      },{
        "@type": "Question",
        "name": "Why do we calculate CPM?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The CPM can benefit your business because it helps you increase sales conversion rates. Advertisements with high conversion rates often perform well when the advertiser pays per thousand views. Moreover, optimizing CPM is an excellent way to create or raise the value of your business and make it stand out."
        }
      },{
        "@type": "Question",
        "name": "Is higher CPM better?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. A high CPM rate often indicates that your campaign is underperforming and you need improvement to increase the number of impressions for your ads."
        }
      },{
        "@type": "Question",
        "name": "What is the average CPM?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The average CPM is the sum of all the CPMs for your different ads. Facebook and Instagram's average CPM for social media advertising in 2021 is approximately $9, whereas this figure for Twitter and Linkedin is roughly $6.50."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        cost: null,
        cpm: null,
        impressions: null
      })
    }
  },
  methods: {
    onCpmCalculator() {
        this.form.post(`/tool/cpm-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          this.form.errors.set(e.response.data.errors);
          this.data = null;
        });
    },
    onSample(){
        this.form.cost = 100;
        this.form.cpm  = 10;
    },
    onReset(){
        this.form.reset();
        this.data = null;
    }
  }
}
